import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * useProducts
 * -----------
 * Fetches the live product catalog from `/api/products` (Mongo-backed).
 * Returns `{ products, loading, error, byId, byCategory }` so consumers can
 * derive their own slices without re-fetching.
 *
 * Single source of truth: the backend. Hardcoded `data/products.js` is no
 * longer used for catalog data — only UI-only constants (categories, hero
 * portrait, etc.) live there.
 */
export function useProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/products");
        if (!cancelled) setProducts(data.products || []);
      } catch (err) {
        if (!cancelled) setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const byId = (id) => products.find((p) => p.id === id);
  const byCategory = (cat) =>
    cat === "all" ? products : products.filter((p) => p.category === cat);

  return { products, loading, error, byId, byCategory };
}
